export const PUBLICATION_OVERVIEW_BLOCK_FIELDS_TITLE_CONSTS = {
  characterLimitReachedMsg: 'Достигнут лимит по кол-ву символов',
  fieldIsRequiredMsg: 'Поле обязательно к заполнению'
}
